<template>
<svg @mouseover="isHover=true" @mouseout="isHover=false"
   version="1.1"
   id="svg1825"
   xml:space="preserve"
   :width="width"
   :height="height"
   viewBox="2 2 72 72"
   sodipodi:docname="annotated biblography-button.ai"
   inkscape:version="1.1 (ce6663b3b7, 2021-05-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs6"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath16"><path
         d="M 0,56.102 H 56.099 V 0 H 0 Z"
         id="path14" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath44"><path
         d="M 1.95996,54.0659 H 54.4014 V 1.625 H 1.95996 Z"
         id="path42" /></clipPath></defs><sodipodi:namedview
     id="namedview4"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     inkscape:zoom="11.283"
     inkscape:cx="37.401402"
     inkscape:cy="37.445716"
     inkscape:window-width="1848"
     inkscape:window-height="1016"
     inkscape:window-x="72"
     inkscape:window-y="27"
     inkscape:window-maximized="1"
     inkscape:current-layer="g8" />
     <g v-if="!isHover"
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="about the project_mouse over"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(53.9932,27.6777)"><path
             d="m 0,0 c 0.17,-0.443 -3,7.584 -10.665,12.59 -3.37,2.201 -8.232,3.654 -13.195,4.308 -4.046,0.533 -8.365,0.695 -11.175,0.539 -11.715,-0.647 -15.276,-7.059 -15.548,-6.52 -0.5,0.99 8.993,11.093 25.083,9.917 C -4.629,19.31 -0.363,0.953 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(43.5156,40.5288)"><path
             d="m 0,0 c -2.797,1.883 -11.724,4.206 -15.562,4.627 -7.726,0.631 -20.343,0.84 -24.618,-7.068 5.506,4.48 13.548,6.887 23.62,5.806 2.943,-0.262 6.264,-0.841 10.025,-1.983 5.43,-1.486 9.468,-5.541 10.707,-6.883 2.849,-3.085 2.888,-7.908 6.881,-9.939 C 9.681,-8.399 5.082,-3.329 0,0"
             style="fill:#262626;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path24" /></g><g
           id="g26"
           transform="translate(52.6602,16.9277)"><path
             d="m 0,0 c 0,-2.679 -5.419,-2.083 -9.167,-2.083 0,0 -11.166,-2.251 -16.083,-2.167 -4.917,0.084 -15.25,6.5 -17.167,8.834 L -47.75,10.5 c -0.167,2.084 3.167,0.417 7,-0.25 0,0 19.499,-2.833 22.333,-2.583 C -15.583,7.917 -6.833,6.834 -5,5.25 Z"
             style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path28" /></g><g
           id="g30"
           transform="translate(52.3271,19.1787)"><path
             d="m 0,0 c 0,1.086 -0.783,7.603 -13.417,7.916 -20.167,0.5 -32.75,3.583 -34.583,3.25 -0.756,-0.137 -2.437,-0.992 -0.834,-1.25 C -46.25,9.5 -34.581,6.532 -15.584,6 -3.667,5.666 0,-0.417 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(47.7939,14.9697)"><path
             d="m 0,0 c -2.287,0.102 -1.647,1.697 -3.167,1.708 -2.156,-0.393 -3.247,-1.851 -5.351,-2.298 -4.531,-0.721 -11.19,-1.604 -16.824,0 -6.957,2.735 -13.872,9.576 -16.823,13.765 6.208,-0.927 10.215,-3.523 17.588,-3.823 0.83,-2.228 1.596,-4.522 3.822,-5.351 1.114,-0.234 2.425,-0.133 3.06,0 2.655,0.66 3.449,3.177 5.353,4.591 C -4.7,9.685 0.212,7.486 3.763,2.904 4.783,1.862 4.646,-0.21 0,0 m 0.74,7.533 c -4.373,2.591 -12.918,3.767 -21.495,3.349 h -0.764 c -8.003,0.833 -17.708,3.473 -23.704,3.826 3.628,-8.607 11.414,-13.056 19.881,-16.825 4.52,-1.853 14.834,-0.237 17.572,0.234 3.532,0.875 3.849,1.048 7.664,0.531 4.29,-0.582 9.995,2.125 0.846,8.885"
             style="fill:#292929;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path36" /></g><g
           id="g38"><g
             id="g40" /><g
             id="g52"><g
               clip-path="url(#clipPath44)"
               opacity="0"
               id="g50"><g
                 transform="translate(54.4014,2.3828)"
                 id="g48"><path
                   d="m 0,0 c 0,-0.418 -0.282,-0.758 -0.632,-0.758 h -51.175 c -0.352,0 -0.634,0.34 -0.634,0.758 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.282,51.683 0,51.347 0,50.926 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path46" /></g></g></g></g><g
           id="g54"
           transform="translate(54.4014,2.3828)"><path
             d="m 0,0 c 0,-0.418 -0.282,-0.758 -0.632,-0.758 h -51.175 c -0.352,0 -0.634,0.34 -0.634,0.758 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.282,51.683 0,51.347 0,50.926 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path56" /></g></g></g></g>
    <g v-else
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="about the project_button"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(51.4531,28.5093)"><path
             d="m 0,0 c 0.169,-0.444 -3.366,3.501 -9.291,7.675 -3.291,2.318 -8.233,3.655 -13.195,4.308 -4.047,0.534 -8.366,0.695 -11.176,0.539 -11.714,-0.647 -13.545,-3.273 -13.817,-2.734 -0.5,0.99 7.422,7.185 23.512,6.009 C -3.097,14.272 -0.363,0.953 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(50.8516,14.5205)"><path
             d="m 0,0 c -0.853,1.043 -16.975,-2.067 -21.243,-2.27 -14.005,-0.663 -26.396,16.207 -26.354,15.755 0.059,-0.672 7.144,-20.96 37.424,-17.506 C -4.021,-3.318 0.774,-0.948 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path24" /></g><g
           id="g26"
           transform="translate(43.5156,40.5288)"><path
             d="m 0,0 c -2.797,1.883 -11.724,4.206 -15.562,4.627 -7.726,0.631 -20.343,0.84 -24.618,-7.068 5.506,4.48 13.548,6.887 23.62,5.806 2.943,-0.262 6.264,-0.841 10.025,-1.983 5.43,-1.486 9.468,-5.541 10.707,-6.883 2.849,-3.085 2.888,-7.908 6.881,-9.939 C 9.681,-8.399 5.082,-3.329 0,0"
             style="fill:#262626;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path28" /></g><g
           id="g30"
           transform="translate(52.6602,16.9277)"><path
             d="m 0,0 c 0,-2.679 -5.419,-2.083 -9.167,-2.083 0,0 -11.166,-2.251 -16.083,-2.167 -4.917,0.084 -15.25,6.5 -17.167,8.834 L -47.75,10.5 c -0.167,2.084 3.167,0.417 7,-0.25 0,0 19.499,-2.833 22.333,-2.583 C -15.583,7.917 -6.833,6.834 -5,5.25 Z"
             style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(47.7939,14.9697)"><path
             d="m 0,0 c -2.287,0.102 -1.647,1.697 -3.167,1.708 -2.156,-0.393 -3.247,-1.851 -5.351,-2.298 -4.531,-0.721 -11.19,-1.604 -16.824,0 -6.957,2.735 -13.872,9.576 -16.823,13.765 6.208,-0.927 10.215,-3.523 17.588,-3.823 0.83,-2.228 1.596,-4.522 3.822,-5.351 1.114,-0.234 2.425,-0.133 3.06,0 2.655,0.66 3.449,3.177 5.353,4.591 C -4.7,9.685 0.212,7.486 3.763,2.904 4.783,1.862 4.646,-0.21 0,0 m 0.74,7.533 c -4.373,2.591 -12.918,3.767 -21.495,3.349 h -0.764 c -8.003,0.833 -17.708,3.473 -23.704,3.826 3.628,-8.607 11.414,-13.056 19.881,-16.825 4.52,-1.853 14.834,-0.237 17.572,0.234 3.532,0.875 3.849,1.048 7.664,0.531 4.29,-0.582 9.995,2.125 0.846,8.885"
             style="fill:#292929;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path36" /></g><g
           id="g38"
           transform="translate(54.4014,2.3828)"><path
             d="m 0,0 c 0,-0.418 -0.282,-0.758 -0.632,-0.758 h -51.175 c -0.352,0 -0.634,0.34 -0.634,0.758 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.282,51.683 0,51.347 0,50.926 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path40" /></g><g
           id="g42"><g
             id="g44" /><g
             id="g56"><g
               clip-path="url(#clipPath48)"
               opacity="0"
               id="g54"><g
                 transform="translate(54.4014,2.3828)"
                 id="g52"><path
                   d="m 0,0 c 0,-0.418 -0.282,-0.758 -0.632,-0.758 h -51.175 c -0.352,0 -0.634,0.34 -0.634,0.758 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.282,51.683 0,51.347 0,50.926 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path50" /></g></g></g></g></g></g></g>
    <title
      :id="iconName"
      lang="en"
    >About the Database</title>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 56
    },
    height: {
      type: [Number, String],
      default: 56
    },
    iconColor: {
      type: String,
      default: '#84bd9f'
    }
  },
  data () {
    return {
      isHover:false,
    }
  }
}
</script>